<template>
  <Field
    v-slot="{ errors, meta, field }"
    :name="vid"
    :rules="rules"
    :vid="vid"
    :value="getInitialValue()"
    class="column is-12"
  >
    <b-field
      :label="label"
      :message="errors"
      :type="{
        'is-danger': errors && errors.length > 0,
        'is-success': meta.valid,
      }"
      class="file is-primary column is-12"
    >
      <template #label>
        <span
          v-if="required"
          class="required"
        >{{ $t("ponctuation.star") }}</span>
        <span class="label">{{ label }}</span>
      </template>
      <b-taginput
        v-if="multiplicity === 'MANY'"
        v-model="dateValue[vid]"
        v-bind="field"
        required
        type="text"
        @blur="updateValue"
        @input="updateValue"
      />
      <InputDate
        v-else
        v-model="dateValue[vid]"
        v-bind="field"
        :format="checker.pattern"
        :from="dateValue[vid]"
        :is-simple-value="true"
        input-type="date"
        @update:date-value="event => {
          updateValue(event, field);
        }"
      />
    </b-field>
  </Field>
</template>

<script lang="ts">
import { Field } from "vee-validate";
import { watch, ref, reactive } from "vue";
import InputDate from "@/components/common/provider/InputDate.vue";
import { datePatternLang, parseDate } from "@/composable/application/datePattern";
import dayjs from "@/plugins/dayjs";

export default {
  name: "OreInputDate",
  components: {
    InputDate,
    Field,
  },
  props: {
    checker: {
      type: Object,
      required: false,
    },
    value: {
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    vid: {
      type: String,
      required: false,
    },
  },
  emits: ["update:value"],
  setup(props, ctx) {
    const val = ref(props.value);
    watch(
      () => props.value,
      (newValue) => {
        val.value = newValue;
      },
      { immediate: true },
    );

    const dateValue = reactive({});
    watch(
      () => [props.vid, val.value, props.checker.pattern],
      ([vid, value, pattern]) => {
        if (typeof value === "string") {
          dateValue[vid] = parseDate(value, pattern);
        }
        else {
          dateValue[vid] = value;
        }
      },
      { immediate: true },
    );

    function updateValue(event, field) {
      if (typeof event == "object") {
        if (event.value instanceof Date) {
          event = datePatternLang(new Date(event.value).toISOString(), props.checker.pattern);
        }
        else {
          event = event.value;
        }
      }
      field.onInput(event);
      ctx.emit("update:value", event);
    }

    function getInitialValue() {
      return dayjs(dateValue[props.vid]).format(props.checker.pattern.replace("dd", "DD"));
    }

    return {
      updateValue,
      val,
      dateValue,
      getInitialValue,
    };
  },
  computed: {
    required: {
      get() {
        return this.checker && this.checker.required;
      },
    },
    multiplicity: {
      get() {
        return this.checker && this.checker.multiplicity === "MANY";
      },
    },
    isValidDate: {
      get() {
        return this.parsedDate === this.value;
      },
    },
    rules: {
      get() {
        let rules = [];
        if (this.checker) {
          if (this.checker.type === "DateChecker") {
            if (this.checker.pattern) {
              rules.push("date:" + this.checker.pattern);
            }
          }
          if (this.checker.required) {
            rules.push("required");
          }
        }
        return rules.join("|");
      },
    },
  },
};
</script>

<style scoped>
.required {
  color: rgb(255, 0, 0);
  padding-right: 5px;
  font-size: 150%;
}
</style>
